module.exports = __webpack_public_path__ + "static/img/guide-09.3b26250d.png";